import { varIs, varKey, varLabel } from "common/var";
import {
  CountryFlag,
  RankBadge,
  Select,
  TablePanel,
  UserAvatar,
} from "components/common";
import { useEffect, useState } from "react";
import {
  FaFacebookMessenger,
  FaTelegramPlane,
  FaWhatsapp,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import { callGetApiWithAuth } from "utils/api";
import { asDate, asVolume } from "utils/text";
import QualModal from "./QualModal";
import UplineBar from "./UplineBar";

export default function ListTable(props) {
  const myUser = useSelector((state) => state.auth.user);
  const [tableData, setTableData] = useState([]);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 15,
    total: 0,
  });
  const [searchParam, setSearchParam] = useState({
    status: "",
    type: "",
    sort_by: "eop",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [uplines, setUplines] = useState([]);
  const [selectedQual, setSelectedQual] = useState(false);

  const onGetTableData = (res) => {
    setTableData(res.data.childrenData.data);
    setPaginationParam({
      ...paginationParam,
      currentPage: res.data.childrenData.current_page,
      total: res.data.childrenData.total,
    });
    setUplines(res.data.uplines);
    setIsLoading(false);
  };
  const onFailTableData = () => {
    setIsLoading(false);
  };
  const loadTableData = (paginationParam0, searchParam0) => {
    setIsLoading(true);
    const params = {
      user_id: props.selectedId,
      ...searchParam0,
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    callGetApiWithAuth(
      `my_team/unilevel_list/table?${q}`,
      onGetTableData,
      onFailTableData
    );
  };
  const onPageChange = (page) => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: page,
    };
    loadTableData(paginationParam0, searchParam);
  };

  useEffect(() => {
    if (myUser) {
      const paginationParam0 = {
        ...paginationParam,
        currentPage: 1,
      };
      setPaginationParam(paginationParam0);
      loadTableData(paginationParam0, searchParam);
    }
  }, [myUser, props.selectedId, searchParam]);

  return (
    <>
      <TablePanel
        title={
          <div className="enrollerList d-flex align-items-center gap-1">
            {`Enroller List`}
            <span style={{ width: 8 }} />
            <StatusSelectWrapper>
              <Select
                value={searchParam.status}
                options={[
                  { label: "All", value: "" },
                  { label: "Active", value: "active" },
                  { label: "Inactive", value: "inactive" },
                  { label: "Closed", value: "closed" },
                  { label: "Purged", value: "purged" },
                ]}
                onChange={(v) =>
                  setSearchParam({
                    ...searchParam,
                    status: v,
                  })
                }
              />
            </StatusSelectWrapper>
            <span style={{ width: 8 }} />

             <StatusSelectWrapper>
              <Select
                  value={searchParam.type}
                  options={[
                    { label: "SM & Customer", value: "" },
                    { label: "Social Marketer", value: "social_marketer" },
                    { label: "Customer", value: "customer" }
                  ]}
                  onChange={(v) =>
                    setSearchParam({
                      ...searchParam,
                      type: v,
                    })
                  }
                />
              </StatusSelectWrapper>
            <span style={{ width: 8 }} />
      
            <label>Sort By</label>
            <span style={{ width: 4 }} />
            <StatusSelectWrapper>
              <Select
                value={searchParam.sort_by}
                options={[
                  { label: "EOP", value: "eop" },
                  { label: "Promoter Rank", value: "rank_id" },
                  { label: "Builder Rank", value: "builder_rank_id" },
                ]}
                onChange={(v) =>
                  setSearchParam({
                    ...searchParam,
                    sort_by: v,
                  })
                }
              />
            </StatusSelectWrapper>
          </div>
        }
        data={tableData}
        loading={isLoading}
        paginationParam={paginationParam}
        onPageChange={onPageChange}
        toolbar={<UplineBar uplines={uplines} goUser={props.goUser} />}
        columns={[
          {
            title: "ID",
            key: "uuid",
            render: (_, record) => <span>#{record.uuid}</span>,
          },
          {
            title: "Level",
            key: "level",
            render: (_, record) => <span>{record.level}</span>,
          },
          {
            title: "Username",
            key: "username",
            render: (_, record) => (
              <div className="d-flex align-items-center tableUserName">
                {record.has_children ? (
                  <a
                    href="javascript:void(0)"
                    onClick={() => props.goUser(record)}
                  >
                    {record.username}
                  </a>
                ) : (
                  <span>{record.username}</span>
                )}
              </div>
            ),
          },
          {
            title: "Name",
            key: "name",
            render: (_, record) => (
              <div className="d-flex align-items-center">
                <UserAvatar
                  image={record.image}
                  title={`${record.first_name} ${record.last_name}`}
                  status={varKey("user.status", record.status)}
                  type={varKey("user.type", record.type)}
                  typeLabel={varLabel("user.type", record.type)}
                  joinDate={asDate(record.created_at)}
                />
                {record.social_messenger &&
                  record.social_messenger.facebook_enabled * 1 === 1 &&
                  record.social_messenger.facebook_link && (
                    <span className="chat-icon">
                      <FaFacebookMessenger
                        onClick={() => {
                          window.open(
                            record.social_messenger.facebook_link,
                            "_blank"
                          );
                        }}
                      />
                    </span>
                  )}
                {record.social_messenger &&
                  record.social_messenger.telegram_enabled * 1 === 1 &&
                  record.social_messenger.telegram_link && (
                    <span className="chat-icon">
                      <FaTelegramPlane
                        onClick={() => {
                          window.open(
                            record.social_messenger.telegram_link,
                            "_blank"
                          );
                        }}
                      />
                    </span>
                  )}
                {record.social_messenger &&
                  record.social_messenger.whatsapp_enabled * 1 === 1 &&
                  record.social_messenger.whatsapp_link && (
                    <span className="chat-icon">
                      <FaWhatsapp
                        onClick={() => {
                          window.open(
                            record.social_messenger.whatsapp_link,
                            "_blank"
                          );
                        }}
                      />
                    </span>
                  )}
              </div>
            ),
          },
          {
            title: "Country",
            key: "country",
            render: (_, record) => <CountryFlag country={record.country} />,
          },
          {
            title: "Promoter Rank",
            key: "rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Builder Rank",
            key: "builder_rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.builder_rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Subscription",
            key: "subscription",
            render: (_, record) => (
              <span>
                {record.subscription_count * 1 > 0 ? (
                  <span className="subscription-yes">Yes</span>
                ) : (
                  <span className="subscription-no">No</span>
                )}
              </span>
            ),
          },
          {
            title: "MP",
            key: "mp",
            render: (_, record) => (
              <span>{asVolume(record.qualification.mp)}</span>
            ),
          },
          {
            title: "MP (on Subscriptions)",
            key: "c_mp",
            render: (_, record) => (
              <span>{asVolume(record.qualification.c_mp)}</span>
            ),
          },
          {
            title: "AP",
            key: "ap",
            render: (_, record) => (
              <span>{asVolume(record.qualification.ap)}</span>
            ),
          },
          {
            title: "EOP",
            key: "eop",
            render: (_, record) => (
              <span>{asVolume(record.qualification.eop)}</span>
            ),
          },
          {
            title: "OP",
            key: "op",
            render: (_, record) => (
              <span>{asVolume(record.qualification.op)}</span>
            ),
          },
          {
            title: "Membership Update Date",
            key: "upgrade_at",
            render: (_, record) => (
              <span>{asDate(record.upgrade_at)}</span>
            ),
          },
        ]}
      />
      {selectedQual && (
        <QualModal
          selectedQual={selectedQual}
          setSelectedQual={setSelectedQual}
        />
      )}
    </>
  );
}

const StatusSelectWrapper = styled.div`
  width: 200px;
  .ant-select {
    width: 100%;
  }
  .ant-select-selector {
    height: 44px !important;
  }
`;
